import { render, staticRenderFns } from "./CategoryCardSlider.vue?vue&type=template&id=4a417106&scoped=true"
import script from "./CategoryCardSlider.vue?vue&type=script&lang=js"
export * from "./CategoryCardSlider.vue?vue&type=script&lang=js"
import style0 from "./CategoryCardSlider.vue?vue&type=style&index=0&id=4a417106&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a417106",
  null
  
)

export default component.exports